import { TranslationSet } from '../types';

export const generate: TranslationSet = {
  'generate.title': {
    en: 'Generate Diary Entry',
    ja: '日記エントリーを生成',
    es: 'Generar entrada de diario',
    zh: '生成日记条目',
    fa: 'ایجاد یادداشت روزانه'
  },
  'generate.subtitle': {
    en: 'Fill in your baby\'s details to create a beautiful diary entry',
    ja: '赤ちゃんの詳細を入力して美しい日記エントリーを作成します',
    es: 'Rellena los detalles de tu bebé para crear una entrada de diario hermosa',
    zh: '填写宝宝的详细信息，创建美丽的日记条目',
    fa: 'جزئیات کودک خود را پر کنید تا یک یادداشت روزانه زیبا ایجاد کنید'
  },
  'generate.form.babyName': {
    en: 'Baby\'s Name',
    ja: '赤ちゃんの名前',
    es: 'Nombre del bebé',
    zh: '宝宝名字',
    fa: 'نام کودک'
  },
  'generate.form.age': {
    en: 'Age',
    ja: '年齢',
    es: 'Edad',
    zh: '年龄',
    fa: 'سن'
  },
  'generate.form.date': {
    en: 'Date',
    ja: '日付',
    es: 'Fecha',
    zh: '日期',
    fa: 'تاریخ'
  },
  'generate.form.activities': {
    en: 'Activities',
    ja: 'アクティビティ',
    es: 'Actividades',
    zh: '活动',
    fa: 'فعالیت‌ها'
  },
  'generate.form.milestones': {
    en: 'Milestones',
    ja: 'マイルストーン',
    es: 'Milestones',
    zh: '里程碑',
    fa: 'نقاط عطف'
  },
  'generate.form.mood': {
    en: 'Mood',
    ja: '気分',
    es: 'Mood',
    zh: '心情',
    fa: 'حالت'
  },
  'generate.form.additionalNotes': {
    en: 'Additional Notes',
    ja: '追加のメモ',
    es: 'Notas adicionales',
    zh: '附加说明',
    fa: 'یادداشت‌های اضافی'
  },
  'generate.form.height': {
    en: 'Height (cm)',
    ja: '身長 (cm)',
    es: 'Altura (cm)',
    zh: '身高 (厘米)',
    fa: 'قد (سانتی‌متر)'
  },
  'generate.form.weight': {
    en: 'Weight (kg)',
    ja: '体重 (kg)',
    es: 'Peso (kg)',
    zh: '体重 (公斤)',
    fa: 'وزن (کیلوگرم)'
  },
  'generate.form.diaperChanges': {
    en: 'Diaper Changes',
    ja: 'おむつ交換',
    es: 'Cambios de ropa',
    zh: '尿布更换',
    fa: 'تغییرات پوشک'
  },
  'generate.form.milkIntake': {
    en: 'Milk Intake (ml)',
    ja: 'ミルク摂取量 (ml)',
    es: 'Intake de leche (ml)',
    zh: '奶量 (毫升)',
    fa: 'مصرف شیر (میلی‌لیتر)'
  },
  'generate.form.generateEntry': {
    en: 'Generate Entry',
    ja: 'エントリーを生成',
    es: 'Generar entrada',
    zh: '生成条目',
    fa: 'ایجاد ورودی'
  },
  'generate.form.saveEntry': {
    en: 'Save Entry',
    ja: 'エントリーを保存',
    es: 'Guardar entrada',
    zh: '保存条目',
    fa: 'ذخیره ورودی'
  },
  'generate.placeholder.activities': {
    en: 'e.g., playing, feeding, sleeping',
    ja: '例：遊ぶ、食事、睡眠',
    es: 'Ejemplo: jugar, alimentar, dormir',
    zh: '例如：玩耍、喂食、睡眠',
    fa: 'مثال: بازی، غذا دادن، خوابیدن'
  },
  'generate.placeholder.milestones': {
    en: 'e.g., first smile, rolling over',
    ja: '例：最初の笑顔、寝返り',
    es: 'Ejemplo: primer sonrisa, levantarse',
    zh: '例如：第一次微笑、翻身',
    fa: 'مثال: اولین لبخند، غلتیدن'
  },
  'generate.placeholder.additionalNotes': {
    en: 'Any other notes you want to add?',
    ja: '追加したいメモはありますか？',
    es: '¿Hay alguna otra nota que quieras añadir?',
    zh: '有什么想要添加的笔记吗？',
    fa: 'آیا یادداشت دیگری می‌خواهید اضافه کنید؟'
  },
  'generate.successMessage': {
    en: 'Diary entry generated successfully!',
    ja: '日記エントリーが正常に生成されました！',
    es: 'Entrada de diario generada con éxito!',
    zh: '日记条目生成成功！',
    fa: 'ورودی دفتر خاطرات با موفقیت ایجاد شد!'
  },
  'generate.errorMessage': {
    en: 'Failed to generate diary entry. Please try again.',
    ja: '日記エントリーの生成に失敗しました。もう一度お試しください。',
    es: 'Error al generar entrada de diario. Por favor, inténtalo de nuevo.',
    zh: '生成日记条目失败。请重试。',
    fa: 'ایجاد ورودی دفتر خاطرات با خطا مواجه شد. لطفا دوباره امتحان کنید.'
  },
  'generate.premiumLimitReached': {
    en: 'You have reached the limit for free entries. Upgrade to premium for unlimited entries!',
    ja: '無料エントリーの上限に達しました。無制限のエントリーのためにプレミアムにアップグレードしてください！',
    es: 'Has alcanzado el límite de entradas gratuitas. Subscreve a Premium para tener entradas ilimitadas!',
    zh: '您已达到免费条目的限制。升级到高级版可获得无限条目！',
    fa: 'شما به حداکثر تعداد ورودی‌های رایگان رسیده‌اید. برای ورودی‌های نامحدود به نسخه پریمیوم ارتقا دهید!'
  },
  'generate.limitReachedAction': {
    en: 'Upgrade Now',
    ja: '今すぐアップグレード',
    es: 'Subscreve ahora',
    zh: '立即升级',
    fa: 'اکنون ارتقا دهید'
  },
  'generate.premiumActive': {
    en: 'Premium Active',
    ja: 'プレミアムアクティブ',
    es: 'Premium activo',
    zh: '高级版已激活',
    fa: 'حساب ویژه فعال است'
  },
  'generate.premiumActiveDescription': {
    en: 'You have access to all premium features, including unlimited diary entries!',
    ja: '無制限の日記エントリーを含むすべてのプレミアム機能にアクセスできます！',
    es: 'Tienes acceso a todas las funciones premium, incluyendo entradas ilimitadas!',
    zh: '您可以访问所有高级功能，包括无限日记条目！',
    fa: 'شما به تمام ویژگی‌های حساب ویژه، از جمله ورودی‌های دفتر خاطرات نامحدود، دسترسی دارید!'
  },
  'generate.profileSetup': {
    en: 'Setup Baby Profile First',
    ja: '最初に赤ちゃんのプロフィールを設定',
    es: 'Configura el perfil del bebé primero',
    zh: '首先设置宝宝档案',
    fa: 'ابتدا پروفایل کودک را تنظیم کنید'
  },
  'generate.profileSetupDescription': {
    en: 'Before creating entries, let\'s set up your baby\'s profile',
    ja: 'エントリーを作成する前に、赤ちゃんのプロフィールを設定しましょう',
    es: 'Antes de crear entradas, configura primero el perfil de tu bebé',
    zh: '在创建条目之前，让我们设置您宝宝的档案',
    fa: 'قبل از ایجاد ورودی، بیایید پروفایل کودک شما را تنظیم کنیم'
  },
  'generate.form.babyNameLoaded': {
    en: 'This field is loaded from your baby\'s profile',
    ja: 'この項目は赤ちゃんのプロフィールから読み込まれています',
    es: 'Este campo se carga desde el perfil de tu bebé',
    zh: '此字段从宝宝档案中加载',
    fa: 'این فیلد از پروفایل کودک شما بارگیری شده است'
  },
  'generate.form.generating': {
    en: 'Generating...',
    ja: '生成中...',
    es: 'Generando...',
    zh: '生成中...',
    fa: 'در حال تولید...'
  },
  'generate.form.generatedEntryTitle': {
    en: 'Your Generated Diary Entry',
    ja: '生成された日記エントリー',
    es: 'Tu entrada de diario generada',
    zh: '生成的日记条目',
    fa: 'ورودی دفتر خاطرات تولید شده شما'
  },
  'generate.form.babyBirthday': {
    en: 'Baby\'s Birthday',
    ja: '赤ちゃんの誕生日',
    es: 'Cumpleaños del bebé',
    zh: '宝宝生日',
    fa: 'تاریخ تولد کودک'
  },
  'generate.form.currentAge': {
    en: 'Current age',
    ja: '現在の年齢',
    es: 'Edad actual',
    zh: '当前年龄',
    fa: 'سن فعلی'
  },
  'generate.form.babyAge': {
    en: 'Baby\'s Age',
    ja: '赤ちゃんの年齢',
    es: 'Edad del bebé',
    zh: '宝宝年龄',
    fa: 'سن کودک'
  },
  'generate.form.babyMetrics': {
    en: 'Baby\'s Metrics',
    ja: '赤ちゃんの指標',
    es: 'Métricas del bebé',
    zh: '宝宝指标',
    fa: 'معیارهای کودک'
  },
  'generate.form.moodToday': {
    en: 'Mood Today',
    ja: '今日の気分',
    es: 'Estado de ánimo hoy',
    zh: '今日心情',
    fa: 'حالت امروز'
  },
  'generate.form.addPhotos': {
    en: 'Add Photos',
    ja: '写真を追加',
    es: 'Añadir fotos',
    zh: '添加照片',
    fa: 'اضافه کردن عکس'
  },
  'generate.form.uploadImages': {
    en: 'Upload Images',
    ja: '画像をアップロード',
    es: 'Subir imágenes',
    zh: '上传图片',
    fa: 'بارگذاری تصاویر'
  },
  'generate.form.activitiesToday': {
    en: 'Activities Today',
    ja: '今日のアクティビティ',
    es: 'Actividades de hoy',
    zh: '今日活动',
    fa: 'فعالیت‌های امروز'
  },
  'generate.form.activityPlaceholder': {
    en: 'e.g. 6 months, 1 year',
    ja: '例：6ヶ月、1年',
    es: 'ej. 6 meses, 1 año',
    zh: '例如：6个月，1年',
    fa: 'به عنوان مثال 6 ماه، 1 سال'
  },
  'generate.form.babyMetricsDescription': {
    en: 'Baby\'s Metrics',
    ja: '赤ちゃんの測定値',
    es: 'Métricas del bebé',
    zh: '宝宝测量值',
    fa: 'اندازه‌گیری‌های کودک'
  },
  'generate.moods.happy': {
    en: 'Happy',
    ja: '嬉しい',
    es: 'Feliz',
    zh: '快乐',
    fa: 'شاد'
  },
  'generate.moods.calm': {
    en: 'Calm',
    ja: '穏やか',
    es: 'Tranquilo',
    zh: '平静',
    fa: 'آرام'
  },
  'generate.moods.curious': {
    en: 'Curious',
    ja: '好奇心旺盛',
    es: 'Curioso',
    zh: '好奇',
    fa: 'کنجکاو'
  },
  'generate.moods.fussy': {
    en: 'Fussy',
    ja: '機嫌が悪い',
    es: 'Irritable',
    zh: '挑剔',
    fa: 'زودرنج'
  },
  'generate.moods.sleepy': {
    en: 'Sleepy',
    ja: '眠い',
    es: 'Soñoliento',
    zh: '困倦',
    fa: 'خواب آلود'
  },
  'generate.activities.tummyTime': {
    en: 'Tummy time',
    ja: 'うつ伏せタイム',
    es: 'Tiempo boca abajo',
    zh: '趴着时间',
    fa: 'زمان روی شکم'
  },
  'generate.activities.bathTime': {
    en: 'Bath time',
    ja: 'お風呂タイム',
    es: 'Tiempo de baño',
    zh: '洗澡时间',
    fa: 'زمان حمام'
  },
  'generate.activities.reading': {
    en: 'Reading',
    ja: '読書',
    es: 'Lectura',
    zh: '阅读',
    fa: 'خواندن'
  },
  'generate.activities.play': {
    en: 'Play',
    ja: '遊び',
    es: 'Juego',
    zh: '玩耍',
    fa: 'بازی'
  },
  'generate.activities.feeding': {
    en: 'Feeding',
    ja: '授乳',
    es: 'Alimentación',
    zh: '喂食',
    fa: 'غذا دادن'
  },
  'generate.activities.nap': {
    en: 'Nap',
    ja: 'お昼寝',
    es: 'Siesta',
    zh: '小睡',
    fa: 'چرت زدن'
  },
  'generate.activities.outdoors': {
    en: 'Outdoors',
    ja: '外出',
    es: 'Al aire libre',
    zh: '户外',
    fa: 'فضای باز'
  },
  'generate.activities.music': {
    en: 'Music',
    ja: '音楽',
    es: 'Música',
    zh: '音乐',
    fa: 'موسیقی'
  },
  'generate.milestones.firstSmile': {
    en: 'First smile',
    ja: '初めての笑顔',
    es: 'Primera sonrisa',
    zh: '第一次微笑',
    fa: 'اولین لبخند'
  },
  'generate.milestones.rolledOver': {
    en: 'Rolled over',
    ja: '寝返り',
    es: 'Rodó por primera vez',
    zh: '翻身',
    fa: 'غلتیدن'
  },
  'generate.milestones.firstWord': {
    en: 'First word',
    ja: '初めての言葉',
    es: 'Primera palabra',
    zh: '第一个单词',
    fa: 'اولین کلمه'
  },
  'generate.milestones.firstSteps': {
    en: 'First steps',
    ja: '初めての一歩',
    es: 'Primeros pasos',
    zh: '第一步',
    fa: 'اولین قدم‌ها'
  },
  'generate.milestones.firstTooth': {
    en: 'First tooth',
    ja: '初めての歯',
    es: 'Primer diente',
    zh: '第一颗牙齿',
    fa: 'اولین دندان'
  },
  'generate.milestones.firstLaugh': {
    en: 'First laugh',
    ja: '初めての笑い声',
    es: 'Primera risa',
    zh: '第一次笑声',
    fa: 'اولین خنده'
  },
  'generate.milestones.sittingUp': {
    en: 'Sitting up',
    ja: 'お座り',
    es: 'Sentarse',
    zh: '坐起来',
    fa: 'نشستن'
  },
  'generate.pregnancyJourney': {
    en: 'Pregnancy Journey Photos',
    ja: '妊娠の旅の写真',
    es: 'Fotos del viaje de embarazo',
    zh: '孕期旅程照片',
    fa: 'عکس‌های سفر بارداری'
  },
  'generate.selectWeek': {
    en: 'Select a Week',
    ja: '週を選択',
    es: 'Selecciona una semana',
    zh: '选择一周',
    fa: 'انتخاب یک هفته'
  },
  'generate.week': {
    en: 'Week',
    ja: '週',
    es: 'Semana',
    zh: '周',
    fa: 'هفته'
  },
  'generate.photosFrom': {
    en: 'Photos from',
    ja: 'からの写真',
    es: 'Fotos de',
    zh: '照片来自',
    fa: 'عکس‌ها از'
  },
  'generate.noPhotosYet': {
    en: 'No photos added for {week} yet.',
    ja: '{week}の写真はまだ追加されていません。',
    es: 'Aún no se han añadido fotos para {week}.',
    zh: '还没有为{week}添加照片。',
    fa: 'هنوز عکسی برای {week} اضافه نشده است.'
  },
  'generate.selectWeekToView': {
    en: 'Select a week to view pregnancy photos',
    ja: '妊娠写真を表示する週を選択してください',
    es: 'Selecciona una semana para ver las fotos del embarazo',
    zh: '选择一周查看孕期照片',
    fa: 'یک هفته را برای مشاهده عکس‌های بارداری انتخاب کنید'
  }
};
